import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Label, OverlayTrigger, Tooltip } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonTable from '../../CommonTable/CommonTable';

import history from '../../../core/history';
import messages from '../../../locale/messages';
import { removePayout } from '../../../actions/Payout/removePayoutAction';
import { setDefaultPayout } from '../../../actions/Payout/setDefaultPayout';
import { verifyPayout } from '../../../actions/Payout/verifyPayout';

import toolTipIcon from '/public/SiteIcons/editInfoTipIcon.svg';
import deleteIcon from '/public/SiteIcons/deleteIcon.svg';
import addIcon from '/public/SiteIcons/addListIcon.svg';

import bt from '../../../components/commonStyle.css';
import s from '../Payout.css';

const PayoutList = ({ data }) => {
  const payoutRemoveLoader = useSelector(state => state.loader.payoutRemove);
  const payoutDefaultLoader = useSelector(state => state.loader.payoutDefault);
  const payoutVerifyLoader = useSelector(state => state.loader.payoutVerify);
  const userId = useSelector(state => state.account.data.userId);

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const handleClick = () => {
    history.push('/user/addpayout');
  }

  const thead = () => {
    return [
      { data: formatMessage(messages.payoutTitle) },
      { data: formatMessage(messages.payoutTitle4) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.options) },
      { data: formatMessage(messages.remove) }
    ]
  }

  const tbody = () => {
    return data?.map((value, key) => {
      return {
        id: key,
        data: [
          {
            data: <div className={s.methodsFlex}>
              {value?.paymentMethod?.name}
              {value?.default && <Label bsStyle="success"><FormattedMessage {...messages.default} /></Label>}
            </div>
          },
          {
            data: <span>{
              value.methodId == 1 && <span>
                {value.payEmail}
              </span>
            }
              {
                value.methodId == 2 && <span className={'rtlPayoutEmail'}>
                  ******{value.last4Digits}
                </span>
              }
              < span className={'rtlPayoutEmail'} > ({value.currency})</span >
            </span>
          },
          {
            data: <span>
              {
                value?.isVerified === true ? <FormattedMessage {...messages.ready} />

                  : <FormattedMessage {...messages.notReady} />
              }
            </span>
          },
          {
            data: <span>
              {
                !value?.default && value?.isVerified === true && <a
                  href="javascript:void(0)"
                  className={cx({ [s.transparentText]: payoutDefaultLoader }, s.linkText)}
                  onClick={() => {
                    if (!payoutDefaultLoader && !payoutRemoveLoader) {
                      dispatch(setDefaultPayout(value?.id))
                    }
                  }}
                >
                  <FormattedMessage {...messages.setDefault} />
                </a>
              }
              {
                !value?.default && value?.isVerified !== true && <a
                  href="javascript:void(0)"
                  onClick={() => {
                    if (!payoutVerifyLoader && !payoutRemoveLoader) {
                      dispatch(verifyPayout(value?.payEmail, userId));
                    }
                  }}
                  className={cx(s.linkText, 'svgImg')}
                >
                  <FormattedMessage {...messages.payoutVerify} />
                  <OverlayTrigger
                    overlay={<Tooltip id={'tooltip' + key}>{formatMessage(messages.payoutVerifyStripeInfo)}</Tooltip>}
                    placement="top"
                  >
                    <img src={toolTipIcon} className={cx(s.toolTipIcon, 'payoutToolRTL')} />
                  </OverlayTrigger>
                </a>
              }
            </span>
          },
          {
            data: <span>
              {
                !value.default && <a
                  className={cx(s.textSpace, 'payOutSpace', { [s.transparentText]: payoutRemoveLoader })}
                  href="javascript:void(0)"
                  onClick={() => {
                    if (!payoutRemoveLoader && !payoutDefaultLoader) {
                      dispatch(removePayout(value.id));
                    }
                  }}
                >
                  <img src={deleteIcon} />
                </a>
              }
            </span>
          }
        ]
      }
    })
  }


  return (
    <div className={cx('commonListingBg', 'payoutStepBg', 'noMarginBottom')}>
      <h3 className={s.titleText}>{formatMessage(messages.payoutMethod)}</h3>
      <p className={cx(s.textMuted)}>
        <FormattedMessage {...messages.payoutTitleBlock1} />
      </p>
      <CommonTable
        thead={thead}
        tbody={tbody}
      />
      <div className='doubleBtnFlexEnd'>
        <span className={cx(s.textMuted)}>&nbsp;<FormattedMessage {...messages.directDeposit} /></span>
        <Button className={cx(bt.btnLarge, bt.btnPrimary, s.addBtn)} onClick={handleClick}>
          <img src={addIcon} className={cx(s.plusIcon, 'addPlusIcon')} />
          <FormattedMessage {...messages.addListing} />
        </Button>
      </div>
    </div>
  );
}

PayoutList.defaultProps = {
  payoutRemoveLoader: false,
  payoutDefaultLoader: false,
  payoutVerifyLoader: false,
  data: []
};

export default withStyles(bt, s)(PayoutList);